import { useRouter } from "nextjs-toploader/app";
import {
  GETTING_STARTED_TASKS_BY_ID,
  gettingStartedTaskHref,
  JURNI_CORE_TASK_ID,
} from "@/constants/getting-started";
import { getJurniCoreActivationLink } from "@/constants/shopify";
import { useShopStore } from "@/store/shopStore";

// Shopify stores activate Jurni Core in the theme editor; other stores install the script from settings.
export const useJurniCoreActivation = () => {
  const router = useRouter();
  const { shopType, shopDomain } = useShopStore();

  return () => {
    if (shopType === "SHOPIFY" && shopDomain) {
      window.open(getJurniCoreActivationLink(shopDomain), "_blank");
      return;
    }
    router.push(
      gettingStartedTaskHref(GETTING_STARTED_TASKS_BY_ID[JURNI_CORE_TASK_ID]),
    );
  };
};
